// extracted by mini-css-extract-plugin
export default {"long-border":"LongBorder_long-border__jjgEw","with-toolbar":"LongBorder_with-toolbar__KAovb","with-tabbar":"LongBorder_with-tabbar__ghTcs","hidden":"LongBorder_hidden__EX7gl"};